var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showFullScreenBtn)?_c('common-icon',{attrs:{"type":_vm.value ? '_fullscreen-exit' : '_fullscreen',"size":23},nativeOn:{"click":function($event){return _vm.handleChange.apply(null, arguments)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }